<template>
  <div>
    <el-descriptions border :column="1">
      <el-descriptions-item label="记录编号">{{ info.id }}</el-descriptions-item>
      <el-descriptions-item label="公司名称">{{ info.company }}</el-descriptions-item>
      <el-descriptions-item label="营业执照">
        <cloud-img v-if="utils.string.vNotEmpty(info.licenseUrl)" :url="info.licenseUrl"></cloud-img>
        <div v-else class="info-text">无营业执照</div>
      </el-descriptions-item>
      <el-descriptions-item label="在职证明">
        <cloud-img v-if="utils.string.vNotEmpty(info.workProofUrl)" :url="info.workProofUrl"></cloud-img>
        <div v-else class="info-text">无在职证明</div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>

import {user} from "@/api/user";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import {utils} from "@/util/utils";

export default {
  name: 'CusCertification',
  computed: {
    utils() {
      return utils
    }
  },
  components: {CloudImg},

  props: {
    userId: Number
  },

  data() {
    return {
      info: {},
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      user.getCusCompanyCertificationVO(this.userId).then(res => {
        this.info = res.data;
      })
    },
  },


};
</script>

<style scoped>
</style>
